module.exports = __webpack_public_path__ + "static/img/share_popup.6ae9ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/ani-event/dialog/share_popup.png
// module id = 36h/
// module chunks = 1